import { useState } from 'react';

interface GeneralRestrictions {
  [key: string]: boolean;
}

export const useGeneralRestrictions = () => {
  const [restrictions, setRestrictions] = useState<GeneralRestrictions>({
    block_gifs: false,
    block_ads: false,
    safe_search: false,
    block_downloads: false,
    block_incognito: false,
    time_restrictions: false
  });
  const [isLoading, setIsLoading] = useState(false);

  const updateRestriction = async (restrictionId: string, enabled: boolean) => {
    console.log('Update restriction:', restrictionId, enabled);
    setRestrictions(prev => ({
      ...prev,
      [restrictionId]: enabled
    }));
  };

  return {
    restrictions,
    updateRestriction,
    isLoading,
    refetch: () => {
      // Would fetch from Convex
    },
  };
};